export default "__VITE_ASSET__6b4f2407__"